export default __webpack_public_path__ + "static/media/ic_clear.7e664d19.svg";